import { createFileRoute } from '@tanstack/react-router';
import { LandedCostRegister } from '../../../features/landed-cost/LandedCostRegister';

/** Owned by G-WebB. Landed cost (haulage/freight) allocation across goods
 * receipt lines (BUILD_SPEC.md §5.4, §9.3, §8.1 step 5) — reached via
 * ReceiptsRegister's "Allocate landed cost" button rather than a tab (it isn't
 * in purchasing-intake.tsx's TABS list). */
export const Route = createFileRoute('/_authenticated/purchasing-intake/landed-cost')({
  component: LandedCostRegister,
});
